// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"9854e40f","52":"66ceff20","119":"09c81948","158":"1565f6ba","228":"4404ee8e","453":"bedf351a","512":"ef356afd","648":"967880d9","785":"8925bd05"}[chunkId] + ".chunk.js";
};